import { render, staticRenderFns } from "./NoAccess.vue?vue&type=template&id=232527ae&"
import script from "./NoAccess.vue?vue&type=script&lang=js&"
export * from "./NoAccess.vue?vue&type=script&lang=js&"
import style0 from "./NoAccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports